import { useCallback } from 'react';
import { MERGE_PATCH_HEADERS, useApiCall } from './apiHelpers';

export interface UpdateCommunicationInputPayload {
  defChannelId?: number;
  defTitle?: string;
  defDescription?: string | null;
  defSendStart?: string | null;
  defNotSendable?: number;
  targetTitle?: string;
  targetDescription?: string | null;
  targetQueryId?: number | null;
  targetCategoryId?: number | null;
  creationPayload?: Record<string, unknown>;
}

const useUpdateCommunicationInput = () => {
  const { authFetch, isReady, run, isLoading, error } = useApiCall();

  const updateCommunicationInput = useCallback(
    async (id: number, payload: UpdateCommunicationInputPayload): Promise<boolean> => {
      if (!isReady) return false;
      const outcome = await run(
        () => authFetch(`/communication_inputs/${id}`, { method: 'PATCH', headers: MERGE_PATCH_HEADERS, body: JSON.stringify(payload) }),
        'Erreur lors de la mise à jour de la communication',
      );
      return outcome.ok;
    },
    [authFetch, isReady, run],
  );

  return { updateCommunicationInput, isLoading, error };
};

export default useUpdateCommunicationInput;
